import { toast } from "react-toastify";

export const HSTSToast = (type = "info", message = "") => {
    const toastOptions = {
      position: "top-center",
      autoClose: 10000, // 10 sec
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    };
  
    const content = (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <span>{message}</span>
      </div>
    );
  
    switch (type) {
      case "success":
        toast.success(content, toastOptions);
        break;
      case "error":
        toast.error(content, toastOptions);
        break;
      case "warn":
        toast.warn(content, toastOptions);
        break;
      case "info":
        toast.info(content, toastOptions);
        break;
      default:
        toast(content, toastOptions);
    }
  };